<template>
  <v-form>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          :model-value="startDate"
          @update:model-value="$emit('update:startDate', $event)"
          label="구속일"
          type="date"
          required
          @change="$emit('calculate')"
          variant="outlined"
          color="primary"
          prepend-inner-icon="mdi-calendar"
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="3">
        <v-text-field
          :model-value="years"
          @update:model-value="$emit('update:years', $event === '' ? '' : Number($event))"
          label="형기 (년)"
          type="number"
          min="0"
          max="99"
          required
          variant="outlined"
          color="primary"
          @blur="$emit('hideKeyboard')"
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="3">
        <v-text-field
          :model-value="months"
          @update:model-value="$emit('update:months', $event === '' ? '' : Number($event))"
          label="형기 (월)"
          type="number"
          min="0"
          max="11"
          required
          variant="outlined"
          color="primary"
          @blur="$emit('hideKeyboard')"
        ></v-text-field>
      </v-col>
    </v-row>
    
    <p v-if="errorMessage" class="text-error text-center mb-4">
      {{ errorMessage }}
    </p>
  </v-form>
</template>

<script>
export default {
  name: 'ParoleForm',
  props: {
    startDate: {
      type: String,
      default: ''
    },
    years: {
      type: [Number, String],
      default: ''
    },
    months: {
      type: [Number, String],
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  emits: ['update:startDate', 'update:years', 'update:months', 'calculate', 'hideKeyboard']
}
</script>

<style scoped>
.text-error {
  color: #ff5252;
  font-weight: bold;
}
</style>
